import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createUser as createUserApi } from "../../services/apiUser";
import { toast } from "react-hot-toast";

export function useAddUser() {
    const queryClient = useQueryClient();

    const { mutate: createUser, isLoading: isCreating } = useMutation({
        mutationFn: createUserApi,
        onSuccess: () => {
            toast.success("User created successfully");
            queryClient.invalidateQueries({
                queryKey: ["Users"],
            });
        },
        onError: (err) => toast.error(err.message),
    });

    return { createUser, isCreating };
}
